// extracted by mini-css-extract-plugin
module.exports = {"skill":"skill_skill__2_S36","skillname":"skill_skillname__Fqlqc"};